import Link from "@tiptap/extension-link";

export const CustomLink = Link.extend({
	inclusive: false,
	addAttributes() {
		const parent = (this as any).parent?.() || {};
		return {
			...parent,
			style: {
				default: null,
				parseHTML: (element: HTMLElement) => element.getAttribute("style"),
				renderHTML: (attributes: Record<string, any>) => {
					if (!attributes.style) return {};
					return { style: attributes.style };
				},
			},
		};
	},
});
